// Same mapped/warning/error/unmapped precedence used by the Mapping Overview
// screen, so a profile's status badge is consistent everywhere it appears.
const STATUS_BADGE = {
    mapped: { label: "Mapped", severity: "0", family: "success" },
    warning: { label: "Warning", severity: "1", family: "warning" },
    error: { label: "Error", severity: "3", family: "destructive" },
    skipped: { label: "Skipped" },
    unmapped: { label: "Not mapped" },
};

const statusCellValue = (status) => ({
    ...(STATUS_BADGE[status] || STATUS_BADGE.unmapped),
    color: "main",
});

const mapCard = (json) => {
    const {
        id,
        profile_name,
        profile_headers,
        status,
        created_at,
        updated_at,
        has_mapping,
    } = json;

    return [
        [
            {
                labels: ["ID"],
                value: id,
                type: "number",
                align: "align-left",
            },
        ],
        [
            {
                labels: ["Profile Name"],
                value: profile_name,
                type: "string",
                align: "align-left",
            },
        ],
        [
            {
                labels: ["Profile Headers"],
                value: profile_headers || "-",
                type: "string",
                align: "align-left",
                basis: "40%",
            },
        ],
        [
            {
                labels: ["Status"],
                value: statusCellValue(status),
                type: "fileStatus",
                align: "align-center",
            },
        ],
        [
            {
                labels: ["Created At"],
                value: created_at,
                type: "string",
                align: "align-left",
            },
        ],
        [
            {
                labels: ["Updated At"],
                value: updated_at,
                type: "string",
                align: "align-left",
            },
        ],
        [
            {
                labels: [""],
                value: {
                    id,
                    entity: id,
                    has_mapping: !!has_mapping,
                    customComponent: "Goto",
                },
            },
        ],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        id: json.id,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    {
        label: ["ID"],
        columnName: "id",
        type: "number",
        align: "left",
        editable: false,
        sortable: true,
    },
    {
        label: ["Profile Name"],
        columnName: "profile_name",
        type: "string",
        align: "left",
        editable: true,
        sortable: true,
    },
    {
        label: ["Profile Headers"],
        columnName: "profile_headers",
        type: "string",
        align: "left",
        editable: false,
        sortable: false,
        basis: "25%",
    },
    {
        label: ["Status"],
        columnName: "status",
        type: "fileStatus",
        align: "center",
        editable: false,
        sortable: true,
    },
    {
        label: ["Created At"],
        columnName: "created_at",
        type: "string",
        align: "left",
        editable: false,
        sortable: true,
    },
    {
        label: ["Updated At"],
        columnName: "updated_at",
        type: "string",
        align: "left",
        editable: false,
        sortable: true,
    },
    {
        label: ["Actions"],
        type: "customComponent",
        align: "center"
    },
];

const importProfilesMapper = {
    map: mapper,
    header,
};

export default importProfilesMapper;

